import { render, staticRenderFns } from "./InformeAuditoriaDescripcionGeneral.vue?vue&type=template&id=14817948&"
import script from "./InformeAuditoriaDescripcionGeneral.vue?vue&type=script&lang=js&"
export * from "./InformeAuditoriaDescripcionGeneral.vue?vue&type=script&lang=js&"
import style0 from "./InformeAuditoriaDescripcionGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardTitle,
  VChip,
  VDivider,
  VFlex,
  VLayout,
  VTextField,
})
